<groundworks-modal>
  <groundworks-modal-header
    [title]="title()"
    [isCancellable]="true"
    (cancelModal)="cancel()"
  />
  <groundworks-modal-body>
    @if (hasError()) {
      <groundworks-state-message type="error" message="Failed to cancel job. Please try again." />
    } @else {
      <div class="alert d-flex align-items-center mb-2" [class]="alertClasses()">
        <i class="bi bi-exclamation-circle-fill text-danger me-1"></i>
        <span>{{ message() }}</span>
      </div>
      <form [formGroup]="form">
        <div class="mb-3">
          <label class="form-label" for="cancellationReason">Reason For Cancelling Job <span class="text-danger">*</span></label>
          <ng-select
            id="cancellationReason"
            formControlName="cancellationReason"
            [items]="cancellationReasons()"
            bindLabel="reason"
            placeholder="Please select"
            [class.ng-select-invalid]="submitted() && form.get('cancellationReason')?.invalid"
          ></ng-select>
        </div>
        <div>
          <label class="form-label" for="commentInput">Notes</label>
          <input type="text" id="commentInput" class="form-control" placeholder="Enter additional notes to describe the cancellation reason." formControlName="comment" />
        </div>
      </form>
    }
  </groundworks-modal-body>
  <groundworks-modal-footer [actions]="footerActions()" />
</groundworks-modal>
